import React, {useState} from 'react';
import Header from "../../../layouts/Header";
import {BiCategoryAlt} from "react-icons/bi";

import {showError, showSuccess} from "../../../utils/toastHelper";
import {getWalletDetail} from "../api/ProfileAPIs";
import Loading from "../../../layouts/Loading";
import {SlWallet} from "react-icons/sl";
import {PiInfoLight} from "react-icons/pi";
import {TbDeviceMobileCheck} from "react-icons/tb";
import {GrMoney} from "react-icons/gr";
import {handlePayment, handlePaymentWallet} from "../../orders/api/OrdersAPI";

const currencyFormat = Intl.NumberFormat('en-US');
export default function Wallet() {

    const [loading, setLoading] = useState(true);
    const [wallet, setWallet] = React.useState([]);
    const [amount, setAmount] = React.useState(0);
    const config = window.APP_CONFIG;
    React.useEffect(() => {

        const search = window.location.search;
        const query = new URLSearchParams(search);
        const message = query.get('message');

        if (message) {
            const success = query.get('success');
            success === '1' ? showSuccess(message) : showError(message);
        }

        const fetchTransactions = async () => {
            const params = {}
            try {
                const data = await getWalletDetail(params);
                setWallet(data.data);

            } catch (err) {
                showError(err);
            } finally {
                setLoading(false);
            }
        };
        fetchTransactions();

    }, []);

    const onChargeWallet = async () => {
        try {
            setLoading(true)
            const request = {
                pay_type: 13,
                bank_unique_code: 'saman',
                amount,

            }
            const result = await handlePaymentWallet(request);
            showSuccess(result.message);


            setTimeout(() => {
                window.location.assign(result.data?.paymentURL);

            }, 1000)

            setLoading(false)
        } catch (error) {

            setLoading(false)
            if (error.response) {
                showError(error.response.data.message || "امکان انجام پرداخت وجود ندارد");
            } else {
                showError("خطا در ارتباط با سرور.");
            }
        }


    }

    if (loading) return <Loading/>;

    return (
        <React.Fragment>

            <Header title='کیف پول' hasBack={true}/>

            <div className="modal fade" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel"
                 aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5" id="exampleModalLabel">
                                شارژ کیف پول
                            </h1>

                        </div>
                        <div className="modal-body">
                            <div className="mb-3">
                                <div className="input-group mb-3">

                                    <div className="form-floating ">

                                        <input
                                            type="tel"
                                            inputMode="numeric"
                                            pattern="[0-9]*"
                                            className="form-control text-center text-big-2"
                                            id="mobile"
                                            placeholder=" "
                                            value={amount}

                                            onChange={(e) => {
                                                setAmount(e.target.value)
                                            }}
                                            required
                                        />
                                        <label htmlFor="mobile" className='right-0 text-small-2'>مبلغ شارژ
                                            (ریال) </label>
                                    </div>
                                    <span className="input-group-text">
                        <GrMoney className='text-big-5'/>
                    </span>
                                </div>
                                <div>
    <span className='badge rounded bg-third-color mx-2'
          onClick={() => {
              setAmount(5000000)
          }}
    >
500
        هزار تومان
                                                        </span>
                                    <span className='badge rounded bg-third-color mx-2'
                                          onClick={() => {
                                              setAmount(10000000)
                                          }}
                                    >
1
        میلیون تومان
                                                        </span>
                                    <span className='badge rounded bg-third-color mx-2'
                                          onClick={() => {
                                              setAmount(50000000)
                                          }}
                                    >
5
        میلیون تومان
                                                        </span>
                                </div>

                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">انصراف</button>
                            <button type="button" className="btn bg-primary-color text-white w-50"
                            onClick={onChargeWallet}
                            >شارژ کیف پول</button>
                        </div>
                    </div>
                </div>
            </div>


            <section className="container mt-4 pt-5 px-3 mb-3">
                <div className="wallet-widget mx-auto">

                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <span className="wallet-label">موجودی کیف پول :</span>
                        <span className="wallet-amount">
                        {currencyFormat.format(wallet.balance)}
                            &nbsp;
                            {config.currency}
          </span>
                    </div>

                    {/* گروه دکمه‌ها */}
                    <div className="d-flex gap-2">
                        <button className="btn btn-wallet-primary flex-grow-1" data-bs-toggle="modal"
                                data-bs-target="#exampleModal">
                            افزایش اعتبار
                        </button>

                    </div>
                </div>
            </section>

            <section className="container  rtl pb-5 my-5 ">
                <div className="row">
                    <div className="col-12 home-separator-text ">
                        <BiCategoryAlt className='mx-2'/>
                        آخرین تراکنش ها
                    </div>
                </div>
                {
                    !loading && wallet?.transactions.map(transaction => {
                        return (
                            <div className="row transaction-box m-3 p-3 " key={transaction.id}

                            >
                                <div className="col-2 text-center px-0 ">
                                    {
                                        transaction.increase_amount > 0 ?
                                            <SlWallet className='text-success  fw-bold text-big-5'/>
                                            :
                                            <SlWallet className='text-danger fw-bold text-big-5'/>
                                    }

                                    <div className="text-small-3 p-0 m-0 mt-2 text-center">
                                            <span
                                                className='tr_code badge badge-pill badge-primary bg-secondary text-small-3 w-100 '>
                                            {
                                                transaction.type
                                            }

                                        </span>
                                    </div>

                                </div>
                                <div className="col-10 text-small-2 fw-bold">

                                    {
                                        transaction.title
                                    }

                                    {transaction.description?.length > 1 &&

                                        <div className='fw-normal text-small-3 text-muted mt-2 text-justify'>
                                            <PiInfoLight className='ms-2'/>
                                            {transaction.description}

                                        </div>
                                    }

                                </div>
                                <div className="col-12 fw-bold text-start text-dark text-small-1">
                                    {
                                        transaction.increase_amount > 0 ?
                                            <span className='text-success'>
                                               {currencyFormat.format(transaction.increase_amount)}
                                                &nbsp;
                                                <span className='text-small-4'> {config.currency}</span>
                                            </span>
                                            :
                                            <span className='text-danger'>
                                                {currencyFormat.format(transaction.decrease_amount)}
                                                &nbsp;
                                                <span className='text-small-4'> {config.currency}</span>
                                            </span>

                                    }

                                    <div className='mt-3 text-small-3 text-muted'>
                                        {transaction.date}
                                    </div>
                                </div>

                            </div>
                        )
                    })
                }
                {
                    !loading && wallet.transactions.length === 0 ?
                        <div className='alert alert-secondary text-center text-small-2 mt-3'>
                            تراکنشی در کیف شما پیدا نشد

                        </div> : ''
                }
            </section>

        </React.Fragment>

    );
}

